<template>
    <ContainerContent
        class="mb-16 mt-4"
        max-class="max-w-sm-ceil"
        outer-container
    >
        <v-row>
            <v-col>
                <h1 class="page-title">Jobs</h1>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <strong>
                    Sporting goods and apparel are incredible platforms for learning how to make really cool things.
                </strong>

                <p>
                    At StringKing, we are becoming experts in textiles, plastics, composites, metals, 3D design,
                    mechanical simulation, physical testing, custom manufacturing, robotics, automation, software
                    development, and more.
                </p>

                <p>
                    Our commitment is to creating the best possible products combined with the best possible online
                    experience for our customers. We are constantly learning and challenging ourselves with exciting new
                    projects. Some of our current endeavors include:
                </p>

                <ul class="mb-4">
                    <li>Building automated robotic manufacturing systems.</li>
                    <li>Developing custom internal systems for tracking manufacturing, sales, and more.</li>
                    <li>Writing software that integrates and connects multiple physical and digital systems.</li>
                </ul>

                <p>
                    We are looking for smart, curious, hard-working individuals who want to grow their own skill sets and
                    push the envelope of what’s possible with physical manufacturing, robotics and automation, and
                    software development.
                </p>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <h3>Apply Now</h3>
                <p>
                    Interested in working at StringKing? We want to hear from you! Send your
                    resume and desired role to <a href="mailto:jobs@stringking.com">jobs@stringking.com</a>, and we’ll be in touch.
                </p>
            </v-col>
        </v-row>
    </ContainerContent>
</template>

<script lang="ts" setup>
    import ContainerContent from '~/components/ContainerContent/ContainerContent.vue';

    definePageMeta({
        scrollToTop: true,
        alias: [
            '/company/jobs'
        ]
    });

    const $config = useRuntimeConfig();
    const brandTitle = $config.public.brand.title;

    useHead({
        title: `Jobs | ${brandTitle}`,
        meta: [
            {
                name: 'description',
                content: 'Jobs'
            }
        ]
    });
</script>
